import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state = {
  favourites: [],
  favouritesLoading: false,
  favourite: {},
  favouriteLoading: false,
  meta: {},
  checkedFavourite: {},
  checkedFavouriteLoading: false
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
